import './InputErrorMessage.css';

import { IonText } from '@ionic/react';
import { FilterError } from '../../../types/types';
import clsx from 'clsx';

interface InputErrorMessageProps {
  error: FilterError;
  className?: string;
}

const InputErrorMessage = ({ error, className }: InputErrorMessageProps) => {
  if (error === null || !error.length) {
    return null;
  }

  if (!Array.isArray(error)) {
    return (
      <div className={clsx('input-error-container', className)}>
        <IonText color="danger">{error}</IonText>
      </div>
    );
  }

  return (
    <div className={clsx('input-error-container', className)}>
      {error.map((errorMessage, index) => (
        <IonText key={index} color="danger">
          {errorMessage}
        </IonText>
      ))}
    </div>
  );
};

export default InputErrorMessage;
